import styled from 'styled-components/macro';
import { TEXT_LIGHT } from '../../constants';

export const BaseListItem = styled.li`
  margin: 0;
  list-style-type: none;
  font-family: ${TEXT_LIGHT};
`;
